import GraphQLProvider from "./GraphQLProvider";

export default GraphQLProvider;
